// Helper function to get status badge color
export const getStatusBadgeColor = (status: string) => {
  switch (status) {
    case 'CONFIRMED':
      return 'success';
    case 'FAILED':
      return 'danger';
    case 'PENDING':
    default:
      return 'warning';
  }
};
